export default {
  getProfile: (state) => state.profile,
};
